/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_TitleInputs */

const vi_warehouse_position_title = /** @type {(inputs: Warehouse_Position_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí kho`)
};

/**

* @param {Warehouse_Position_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_title = /** @type {((inputs?: Warehouse_Position_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_title(inputs)
});